import { InspectionTicketPostApi } from '../api/models/InspectionApi';
export class InspectionEntity {
  static create(data: InspectionTicketPostApi): InspectionEntity {
    try {
      if (!data || typeof data !== 'object') {
        throw new Error('Invalid data: data must be an object');
      }

      return new InspectionEntity(data);
    } catch (error: any) {
      throw new Error(`Error creating InspectionEntity: ${error.message}`);
    }
  }

  currentDate: string;
  ticketId: string;

  constructor(data: InspectionTicketPostApi) {
    this.currentDate = data.current_date;
    this.ticketId = data.ticket_id;
  }
}
